<template>
    <div>
        <Navbar v-if="$route.name=='examcorrectiondetailsel'"/>
        <!-- <Breadcrumb v-if="$route.name=='examcorrectiondetailsel'" /> -->
        <div class="ps-3">
            Correcting {{ exam.exam_name }} for {{ `${consultant.id} ${consultant.family_name}, ${consultant.first_name }` }}
        </div>
        <div class="row">
            <div class="col">
                <div class="card my-3">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-6">
                                <h6 class="mt-0 mb-0">Exam Questions</h6>
                            </div>
                            <div class="col-6 text-end">
                                <button
                                    @click.prevent="resetCourse"
                                    class="btn btn-secondary"
                                >
                                    Cancel
                                </button>
                                <button
                                    @click.prevent="save_corrections"
                                    class="btn btn-primary ms-3"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th class="d-none">ID</th>
                                        <th class="gdq-w-5">#</th>
                                        <th class="gdq-w-40">Question</th>
                                        <th class="gdq-w-40">Answer</th>
                                        <th class="gdq-w-5">Correct</th>
                                        <th class="gdq-w-10"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in examanswers" :key="item.id">
                                        <td class="d-none">{{ item.id }}</td>
                                        <td class="gdq-w-5">{{ item.examquestion_id }}</td>
                                        <td class="gdq-w-40">{{ item.question_id }}</td>
                                        <td class="gdq-w-40">{{ item.answer }}</td>
                                        <td class="gdq-w-5">
                                            <div class="form-check">
                                                <input 
                                                    type="checkbox" 
                                                    class="form-check-input" 
                                                    v-model="correctStates[item.id]"
                                                />
                                            </div>
                                        </td>
                                        <td class="gdq-w-10">
                                            <button 
                                                class="btn btn-sm btn-primary" 
                                                @click="openCommentsModal(item.id)"
                                            >
                                                Comments
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Comments Modal -->
        <div class="modal fade" :class="{show: showcomms, 'd-block': showcomms}" tabindex="-1" :style="{display: showcomms ? 'block' : 'none'}">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Comments</h5>
                        <button type="button" class="btn-close" @click="closeCommentsModal"></button>
                    </div>
                    <div class="modal-body">
                        <ExamNotes :examanswerId="communicationid"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showcomms" class="modal-backdrop fade show"></div>
    </div>
</template>
<script>
/* eslint-disable no-console */
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
import ExamNotes from './ExamNotes.vue';

export default {
    name: 'ExamCorrectionDetail',
    components: {
        Navbar,
        // Breadcrumb,
        ExamNotes
    },
    props: {
        courseId: {
            type: [String, Number],
            default: ''
        },
        examId: {
            type: [String, Number],
            default: ''
        },
        consultantId: {
            type: [String, Number],
            default: ''
        },
        resetCourse: {
            type: Function,
            required: true
        }
    },
    computed:{
        course_id() {
            if (this.courseId !== '') {
                return this.courseId;
            }
            return this.$route.params.courseId;
        },
        exam_id() {
            let res = null;
            if (this.examId !== '') {
                res = this.examId;
            } else {
                res = this.$route.params.examId;
            }
            return res;
        },
        consultant_id() {
            if (this.consultantId !== '') {
                return this.consultantId;
            }
            return this.$route.params.consultantId;
        }
    },
    data() {
        return {
            exam: {},
            examanswers: [],
            examanswerscolumns: [
                { key: 'id', label: 'ID', sortable: false, thClass: 'd-none', tdClass: 'd-none' },
                { key: 'examquestion_id', label: '#', sortable: true, thClass: 'gdq-w-5', tdClass: 'gdq-w-5' },
                { key: 'question_id', label: 'Question', sortable: false, thClass: 'gdq-w-40', tdClass: 'gdq-w-40' },
                { key: 'answer', label: 'Answer', sortable: false, thClass: 'gdq-w-40', tdClass: 'gdq-w-40' },
                { key: 'answer_correct', label: 'Correct', sortable: true, thClass: 'gdq-w-5', tdClass: 'gdq-w-5' },
                { key: 'actions', label: '', sortable: false, thClass: 'gdq-w-10', tdClass: 'gdq-w-10' },
            ],
            consultant: {},
            questions: [],
            examquestions: [],
            correctStates: {},
            teacherComments: {},
            communicationid: 0,
            showcomms: false,
        }
    },
    async created() {
        await this.exam_get();
        this.consultant_get();
        await this.examquestions_get().then (() => {
            this.consultant_answers_get();
        });
    },
    methods: {
        openCommentsModal(id) {
            this.communicationid = id;
            this.showcomms = true;
        },
        closeCommentsModal() {
            this.communicationid = 0;
            this.showcomms = false;
        },
        async save_corrections() {
            for (let i=0;i<this.examanswers.length; i++) {
                const correctAnswer = this.correctStates[this.examanswers[i].id]
                const rec = {
                    id: this.examanswers[i].id,
                    answer_correct: correctAnswer ? 1 : 0,
                }
                await this.$store.dispatch('record_put', { table_name: 'g_elearning_consultant_exam_answers', id: rec.id, record: rec })
                const commentrec = {
                    examanswer_id: this.examanswers[i].id,
                    examanswer_comment:
                        this.teacherComments[this.examanswers[i].id] ?
                        this.teacherComments[this.examanswers[i].id] :
                        ''
                }
                await this.$store.dispatch(
                    'record_post',
                    {
                        table_name: 'g_elearning_consultant_exam_answer_notes',
                        record: commentrec
                    }
                )
            }
            this.resetCourse();
        },
        async exam_get() {
            this.$store.dispatch('record_read', {
                table_name: 'g_elearning_exams',
                id: this.exam_id
            })
            .then((resp) => {
                this.exam = resp.data;
            })
        },
        consultant_get() {
            this.$store.dispatch('record_read', {
                table_name: 'i_user',
                id: this.consultant_id
            })
            .then((resp) => {
                this.consultant = resp.data;
            })
        },
        async examquestions_get() {
            const filter = {
                exam_id: {
                    value: this.exam_id,
                    operator: '='
                }
            }
            let examquestions = await this.$store.dispatch('records_readlist', {
                table_name: 'g_elearning_exams_questions',
                filter,

            }).then(r => r.data.result);
            for (let i = 0; i < examquestions.length; i++) {
                const answeroptions = await this.$store.dispatch('records_readall', {
                    table_name: 'g_elearning_question_options',
                    page: 1,
                    perPage: 1000
                }).then(r => {
                    return r.data.result
                })
                const thisoptions = answeroptions.filter(o => o.question_id.toString() === examquestions[i]._question_id.toString())
                examquestions[i].options = thisoptions;
            }
            this.examquestions = examquestions;
        },
        async consultant_answers_get() {
            const filter = {
                course_id: {
                    value: this.course_id,
                    operator: '='
                },
                exam_id: {
                    value: this.exam_id,
                    operator: '='
                },
                consultant_id: {
                    value: this.consultant_id,
                    operator: '='
                }
            }
            await this.$store.dispatch('records_readlist', {
                table_name: 'g_elearning_consultant_exam_answers',
                filter,
                page: 1,
                perPage: 1000
            })
            .then((resp) => {
                let examanswers = resp.data.result.map(a => {
                    return {
                        ...a,
                        teacher_comment: '',
                    }
                });
                for (let i = 0; i < examanswers.length; i++) {
                    const examquestion = this.examquestions.find(q => { 
                        return q._question_id.toString() === examanswers[i]._question_id.toString()
                    });
                    for (let j = 0; j < examquestion.options.length; j++) {
                        if (examquestion.options[j].questionoption_value.toString() === examanswers[i].answer.trim().toString()) {
                            examanswers[i].answer = examquestion.options[j].questionoption_text;
                        }
                    }
                    examanswers[i].answer_correct = examanswers[i].answer_correct === '1';
                    this.$store.dispatch('records_readlist',
                        {
                            table_name: 'g_elearning_consultant_exam_answer_notes',
                            filter: {
                                examanswer_id: {
                                    value: examanswers[i].id,
                                    operator: '='
                                }
                            }
                        }
                    ).then((commentsresult) => {
                        const comments = commentsresult.data.result
                        console.log({comments})
                        let comment = '';
                        for (let j=0; j<comments.length; j++) {
                            comment = comment + '\n' + comments[j].examanswer_comment
                        }
                        this.teacherComments[examanswers[i].id] = comment
                        examanswers[i].teacher_comment = comment
                    })
                    this.correctStates[examanswers[i].id] = examanswers[i].answer_correct
                }
                this.examanswers = examanswers;
            })
        }, 
    }   
}
</script>
